export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/DZ-c94b3566b2453d9565e72cd380503b08.png";